export default "__VITE_ASSET__DIbVTDZc__"